import React, { useState, useEffect } from 'react';
import OnboardingTour, { TOUR_STORAGE_KEY } from '../../../components/ui/OnboardingTour';

const WORKOUT_BUILDER_TOUR_KEY = 'workout_builder_v1';

const WORKOUT_BUILDER_STEPS = [
  {
    target: '[data-tour="builder-header"]',
    title: 'Trainer Workout Builder',
    description: 'Welcome to your workout builder! Here you can create fully personalised weekly workout programmes for your clients — from exercise selection to scheduling and assignment.',
    position: 'bottom',
    icon: 'Dumbbell',
  },
  {
    target: '[data-tour="exercise-library"]',
    title: 'Exercise Library',
    description: 'Browse hundreds of categorised exercises. Filter by muscle group, equipment, or difficulty. Click the "+" button on any exercise to instantly add it to your programme.',
    position: 'right',
    icon: 'BookOpen',
  },
  {
    target: '[data-tour="exercise-search"]',
    title: 'Search & Filter Exercises',
    description: 'Use the search bar and dropdown filters to quickly find the perfect exercise. You can also create custom exercises unique to your training style using the "Add Custom" button.',
    position: 'right',
    icon: 'Search',
  },
  {
    target: '[data-tour="workout-timeline"]',
    title: 'Weekly Drag-and-Drop Zone',
    description: 'This is your programme canvas. Drag exercises from the library and drop them into any day of the week. Reorder exercises within a day, set sets/reps/rest, or mark days as rest days.',
    position: 'left',
    icon: 'CalendarDays',
  },
  {
    target: '[data-tour="plan-config"]',
    title: 'Plan Settings & Client Assignment',
    description: 'Name your plan, set the start and end dates, then assign it directly to a client from your roster. Once saved, the plan appears in your client\'s workout dashboard immediately.',
    position: 'left',
    icon: 'UserCheck',
  },
  {
    target: '[data-tour="save-plan-btn"]',
    title: 'Save & Assign Plan',
    description: 'When your programme is ready, hit "Save Plan" to publish it to your client. They\'ll receive the full weekly schedule with all exercises, sets, reps, and rest periods.',
    position: 'top',
    icon: 'CheckCircle',
  },
];

const WorkoutBuilderTour = ({ onComplete, onSkip }) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const completed = localStorage.getItem(TOUR_STORAGE_KEY + WORKOUT_BUILDER_TOUR_KEY);
    if (!completed) {
      // Small delay to let the page fully render before starting tour
      const t = setTimeout(() => setShouldShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  if (!shouldShow) return null;

  return (
    <OnboardingTour
      steps={WORKOUT_BUILDER_STEPS}
      tourKey={WORKOUT_BUILDER_TOUR_KEY}
      onComplete={() => {
        setShouldShow(false);
        onComplete?.();
      }}
      onSkip={() => {
        setShouldShow(false);
        onSkip?.();
      }}
    />
  );
};

export { WORKOUT_BUILDER_TOUR_KEY };
export default WorkoutBuilderTour;
